/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsGripDotsVertical: {
  name: 'grip-dots-vertical';
  data: string;
} = {
  name: 'grip-dots-vertical',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><circle cx="6" cy="2" r="1" fill="currentColor"/><circle cx="10" cy="2" r="1" fill="currentColor"/><circle cx="6" cy="6" r="1" fill="currentColor"/><circle cx="10" cy="6" r="1" fill="currentColor"/><circle cx="6" cy="10" r="1" fill="currentColor"/><circle cx="10" cy="10" r="1" fill="currentColor"/><circle cx="6" cy="14" r="1" fill="currentColor"/><circle cx="10" cy="14" r="1" fill="currentColor"/></svg>`,
};
